import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { callAPI } from "../feature/APISlice";
import { openForm } from "../feature/formSlice";
import AdminNavbar from "./AdminNavbar";
import HomePageGalleryForm from "../Form/HomePageGalleryForm.js";

const BASE_URL = `${process.env.REACT_APP_PRODUCTION_API_URL}backend/api/admin/home-page-galleries`;

export default function HomePageGalleryList() {
  const dispatch = useDispatch();
  const { items, loading, error } = useSelector((s) => s.api);

  useEffect(() => {
    dispatch(callAPI({ method: "get", url: BASE_URL }));
  }, [dispatch]);

  return (
    <div>
      <AdminNavbar />

      <div className="customcontainer">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
          }}
        >
          <button
            className="admin-btn outline"
            onClick={() => dispatch(openForm(null))}
          >
            + Add Gallery Item
          </button>
        </div>

        {loading && <p>Loading...</p>}
        {error && <p className="error-text">{error}</p>}

        <div className="admin-card-grid">
          {items.length > 0 ? (
            items.map((g) => (
              <div className="admin-card" key={g.id}>
                <div className="admin-card-header">
                  <h4 className="admin-card-title">
                    {g.title || "No Title"}
                  </h4>
                </div>

                <p className="admin-card-status">
                  Status: {g.is_active ? " Active" : "❌ Inactive"}
                </p>

                <div className="admin-card-actions">
                  <button
                    className="admin-card-btn"
                    onClick={() => dispatch(openForm(g.id))}
                  >
                    ✏️
                  </button>
                  <button
                    className="admin-card-btn"
                    onClick={() =>
                      window.confirm("Delete this gallery item?") &&
                      dispatch(
                        callAPI({
                          method: "delete",
                          url: `${BASE_URL}/${g.id}`,
                          data: { id: g.id },
                        })
                      )
                    }
                  >
                    🗑️
                  </button>
                </div>
              </div>
            ))
          ) : (
            !loading && <p>No gallery items found.</p>
          )}
        </div>
      </div>

      <HomePageGalleryForm />
    </div>
  );
}
